<template>
  <el-dialog
    width="800px"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    destroy-on-close
    @close="closeDialog"
    :append-to-body="false"
  >
    <div slot="title">
      {{ $t('stores::products-info::sale_manager') }}
    </div>
    <div class="detail">
      <div style="font-size: 16px; font-weight: bold; margin-bottom: 20px">
        {{ $t('stores::products-info::goods_info') }}
      </div>
      <el-row :gutter="20">
        <el-col :span="8" class="detail-item">
          <span>
            <label>SPU:</label>
            {{ product.spuId }}
          </span>
        </el-col>
        <el-col :span="16" class="detail-item">
          <span>
            <label>{{ $t('stores::products-info::name') }}:</label>
            {{ product.title }}
          </span>
        </el-col>
        <el-col :span="8" class="detail-item">
          <span>
            <label>{{ $t('stores::products-info::category') }}:</label>
            {{ product.categoryNames }}
          </span>
        </el-col>
        <el-col :span="16" class="detail-item">
          <span>
            <label>{{ $t('system::responsible::供应商') }}:</label>
            {{ product.supplier }}
          </span>
        </el-col>
      </el-row>
    </div>
    <el-tabs v-model="published" type="card" @tab-click="getSalesList">
      <el-tab-pane :label="$t('stores::products-info::had_release')" name="1"></el-tab-pane>
      <el-tab-pane :label="$t('stores::products-info::not_release')" name="0"></el-tab-pane>
    </el-tabs>
    <el-button
      type="primary"
      style="margin-bottom: 10px"
      :disabled="
        dialogTableSelection.length === 0 ||
        dialogTableSelection.some(item => item.publishStatus === 1 || item.publishStatus === 2)
      "
      @click="batchPublish"
      :loading="publishLoading"
    >
      {{ $t('stores::products-info::batch_had_release') }}
    </el-button>
    <el-table
      :data="sellTableData"
      max-height="240px"
      @selection-change="dialogTableSelectChange"
      v-loading="sellManagementLoading"
    >
      <el-table-column type="selection" :selectable="checkselect"></el-table-column>
      <el-table-column :label="$t('stores::products-info::store')" prop="shopName"></el-table-column>
      <el-table-column :label="$t('stores::products-info::status')" prop="status">
        <template slot-scope="{ row }">
          <div>
            {{ $t('stores::products-info::sale_status') }}:
            {{ row.saleStatus ? $t('stores::products-info::is_sale') : $t('stores::products-info::stop_sale') }}
          </div>
          <div>
            {{ $t('stores::products-info::release_status') }}: {{ getPublishStatus(row.publishStatus) }}
            <i v-if="row.publishStatus === 3" class="el-icon-warning-outline" style="color: red"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('stores::products-info::operate')">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            @click="dialogPublish(row, 'pub')"
            :disabled="[1, 2].includes(row.publishStatus)"
            :loading="row.saleLoading === 'pub'"
          >
            {{ $t('stores::products-info::release') }}
          </el-button>
          <template v-if="published === '1'">
            <el-button
              type="text"
              @click="dialogStopSales(row, 'stop')"
              v-if="row.saleStatus"
              :loading="row.saleLoading === 'stop'"
              :disabled="[0, 1].includes(row.publishStatus)"
            >
              {{ $t('stores::products-info::stop_sale') }}
            </el-button>
            <el-button
              type="text"
              @click="dialogSales(row, 'start')"
              v-else
              :loading="row.saleLoading === 'start'"
              :disabled="[0, 1].includes(row.publishStatus)"
            >
              {{ $t('stores::products-info::is_sale') }}
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import * as Api from '@/server/product'
export default {
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    handleProduct: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      sellManagementLoading: false,
      publishLoading: false,
      sellTableData: [],
      product: {},
      published: '1',
      dialogTableSelection: [],
    }
  },
  watch: {
    handleProduct: {
      handler: function (val) {
        this.product = { ...val }
      },
      immediate: true, // 第一次刷新页面时就会执行
    },
    visible(bool) {
      this.dialogVisible = bool
      if (!bool) {
        this.closeDialog()
      } else {
        this.$nextTick(() => {
          this.getSalesList()
        })
      }
    },
  },
  methods: {
    checkselect(row) {
      return row.publishStatus !== 2
    },
    async getSalesList() {
      this.sellManagementLoading = true
      const { data } = await Api.getSalesList({ spuId: this.product.spuId, published: this.published })
      if (data.code === this.$code) {
        this.sellTableData = data.data.map(item => {
          return { ...item, saleLoading: false }
        })
      }
      this.sellManagementLoading = false
    },
    // 售卖管理  批量发布
    batchPublish() {
      const list = this.dialogTableSelection.map(item => {
        return {
          spu_id: item.spuId,
          shop_id: item.shopId,
        }
      })
      this.publishLoading = true
      Api.publishProd({ publish_vos: list })
        .then(res => {
          if (res.data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.getSalesList()
          }
          this.publishLoading = false
        })
        .catch(() => {
          this.publishLoading = true
        })
    },
    // 售卖管理  发布
    dialogPublish(row, type) {
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::release_to_release', { name: row.shopName }),
        this.$t('stores::products-info::release_again')
      ).then(() => {
        row.saleLoading = type
        Api.publishProd({
          publish_vos: [
            {
              spu_id: row.spuId,
              shop_id: row.shopId,
            },
          ],
        })
          .then(res => {
            row.saleLoading = false
            if (res.data.code === this.$code) {
              this.$message.success(this.$t('system::tip::control_success'))
              this.getSalesList()
            }
          })
          .catch(() => {
            row.saleLoading = false
          })
      })
    },
    // 售卖管理  停售
    dialogStopSales(row, type) {
      const h = this.$createElement
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::dialog_stop_sale_tips', { name: row.shopName }),
        this.$t('stores::products-info::dialog_stop_sale_title')
      ).then(() => {
        row.saleLoading = type
        Api.spuSaleStatus({
          spu_id: row.spuId,
          shop_id: row.shopId,
          publish_status: 0,
        })
          .then(res => {
            row.saleLoading = false
            if (res.data.code === this.$code) {
              if (res.data.data) {
                this.$message({
                  type: 'success',
                  message: h('p', null, [
                    h('span', null, this.$t('stores::products-info::message_stop_sale')),
                    h('span', { style: 'color: #0560FD' }, res.data.data.successCount),
                    h('span', null, `${$t('stores::products-info::message_store_text')}，`),
                    h('span', null, this.$t('stores::products-info::message_stop_fail')),
                    h('span', { style: 'color: #ff4300' }, res.data.data.failCount),
                    h('span', null, this.$t('stores::products-info::message_store_text')),
                  ]),
                })
              }
              this.getSalesList()
            }
          })
          .catch(() => {
            row.saleLoading = false
          })
      })
    },
    // 处理发布状态
    getPublishStatus(status) {
      switch (status) {
        case 0:
          return this.$t('stores::store::goods::release_wait')
        case 1:
          return this.$t('stores::store::goods::release_ing')
        case 2:
          return this.$t('stores::store::goods::release_had')
        case 3:
          return this.$t('stores::store::goods::release_fail')
        default:
          return this.$t('stores::products-info::not_release')
      }
    },
    // 售卖管理  开售
    dialogSales(row, type) {
      const h = this.$createElement
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::dialog_start_sale_tips', { name: row.shopName }),
        this.$t('stores::products-info::dialog_start_sale_title')
      ).then(() => {
        row.saleLoading = type
        Api.spuSaleStatus({
          spu_id: row.spuId,
          shop_id: row.shopId,
          publish_status: 1,
        })
          .then(res => {
            row.saleLoading = false
            if (res.data.code === this.$code) {
              if (res.data.data) {
                this.$message({
                  type: 'success',
                  message: h('p', null, [
                    h('span', null, this.$t('stores::products-info::message_start_sale')),
                    h('span', { style: 'color: #0560FD' }, res.data.data.successCount),
                    h('span', null, `${$t('stores::products-info::message_store_text')}，`),
                    h('span', null, this.$t('stores::products-info::message_stop_fail')),
                    h('span', { style: 'color: #ff4300' }, res.data.data.failCount),
                    h('span', null, this.$t('stores::products-info::message_store_text')),
                  ]),
                })
              }
              this.getSalesList()
            }
          })
          .catch(() => {
            row.saleLoading = false
          })
      })
    },
    dialogTableSelectChange(val) {
      this.dialogTableSelection = val
    },
    handleMessageBox(row, tips, title) {
      console.log(row, 'row')
      return this.$confirm(
        `${tips} <br/ > <div style="width:230px;padding:13px 0;background:#f9f9f9;color:#666;display: inline-block;
    margin-top: 13px;"> ${this.$t('stores::products-info::goods_spu')}：${row.spuId ? row.spuId : row.skuId}</div>`,
        title,
        {
          dangerouslyUseHTMLString: true,
        }
      )
    },
    closeDialog(refresh) {
      this.published = '1'
      this.$emit('closeDialog', refresh)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    max-height: 550px;
    overflow-y: auto;
  }
}
.el-form-item {
  width: 500px;
}
.detail {
  // margin-bottom: 20px;
  .detail-item {
    margin-bottom: 20px;
    label {
      width: 65px;
      display: inline-block;
    }
  }
}
</style>
